import { IDataQualityIndicatorItemInfo } from '~src/catalog/models/IDataQualityIndicatorItemInfo';
import { IPublishedConnectionUsageInfo } from '~src/spacesPlatform/models/IUsageInfo';
import {
  DraftLuidInfo,
  DraftStatusInfo,
  ICreatedItemInfo,
  IDescriptionItemInfo,
  IExplorableItemTypeInfo,
  IFavoriteItem,
  IIdItemInfo,
  IItemStatisticsInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo,
  IPublishedConnectionExtractItemInfo,
  ITaggedItemInfo,
  IUpdatedItemInfo,
} from '~src/spacesPlatform/models/resourceInfoParts';

export interface IPublishedConnectionBase extends
  IExplorableItemTypeInfo<'virtualConnection'>,
  ICreatedItemInfo,
  IDataQualityIndicatorItemInfo,
  IDescriptionItemInfo,
  IFavoriteItem,
  IIdItemInfo,
  INamedItemInfo,
  IOwnedItemInfo,
  IProjectItemInfo,
  IPublishedConnectionExtractItemInfo,
  ITaggedItemInfo,
  IUpdatedItemInfo,
  DraftLuidInfo,
  DraftStatusInfo
{
  luid: string;
}

export interface IPublishedConnectionInfo extends
  IPublishedConnectionBase,
  IItemStatisticsInfo<IPublishedConnectionUsageInfo>
{
}

export interface IPublishedConnectionDetailInfo extends
  IPublishedConnectionBase
{
  tables: IPublishedConnectionTableInfo[];
  publishedConnectionDraft?: IPublishedConnectionDraftInfo;
}

export interface IPublishedConnectionDetailWithUsageInfo extends
  IPublishedConnectionDetailInfo,
  IItemStatisticsInfo<IPublishedConnectionUsageInfo>
{
}

export interface IPublishedConnectionTableInfo {
  alias: string;
  hasExtract: boolean;
  incrementalExtractEnabled: boolean;
  databaseName?: string;
  name: string;
  schemaName?: string;
  luid: string;
}

export interface IPublishedConnectionDraftInfo {
  readonly luid: string;
  readonly ownerId: string;
  readonly createdAt: string; // YYYY-MM-DDThh:mm:ssZ
  readonly updatedAt: string; // YYYY-MM-DDThh:mm:ssZ
}

export function isPublishedConnectionInfo(publishedConnection: IExplorableItemTypeInfo): publishedConnection is IPublishedConnectionInfo {
  return (publishedConnection.contentType === 'virtualConnection');
}
